import React from 'react';
import Breadcrumb, { BreadcrumbItem } from 'view/section/Breadcrumb/Breadcrumb';
import { PrioridadesLista } from 'view/section/PrioridadesLista/PrioridadesLista';
import { H2 } from 'view/component/Tipografia/Texto';
import { Conteudo } from 'view/section/Conteudo/Conteudo';


const PrioridadeSolicitacaoPage: React.FunctionComponent =  () =>{
  return (
    <>
      <Breadcrumb>
        <BreadcrumbItem href="/">Início</BreadcrumbItem>
        <BreadcrumbItem>Prioridades</BreadcrumbItem>
      </Breadcrumb>

      <Conteudo className="solicitacoes-page">
        <header>
          <H2>Prioridades</H2>
        </header>
        
        <section>
          <PrioridadesLista />
        </section>
      </Conteudo>
    </>
  )
}
export default PrioridadeSolicitacaoPage;